
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ExerciseCard } from "./ExerciseCard";

interface TrainingDayProps {
  day: any;
  dayIndex: number;
  weekIndex: number;
}

function TrainingDayComponent({ day, dayIndex, weekIndex }: TrainingDayProps) {
  // Get the day title (focus or session_type)
  const dayTitle = day.focus || day.session_type || `Day ${day.day_number || dayIndex + 1}`;
  
  return (
    <AccordionItem 
      value={`day-${weekIndex}-${dayIndex}`}
      className="border border-white/20 rounded-md overflow-hidden bg-white/5"
    >
      <AccordionTrigger className="px-4 py-2 hover:bg-white/10 text-white">
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="bg-white/10 text-white">
            Day {day.day_number || dayIndex + 1}
          </Badge>
          <span>{dayTitle}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        {day.session_type && day.focus && day.session_type !== day.focus && (
          <div className="mb-2 text-white/70">
            <span className="font-medium">Session Type:</span> {day.session_type}
          </div>
        )}
        
        {day.exercises && day.exercises.length > 0 ? (
          <div className="space-y-4">
            {day.exercises.map((exercise: any, exerciseIndex: number) => (
              <ExerciseCard key={exerciseIndex} exercise={exercise} />
            ))}
          </div>
        ) : (
          <p className="text-white/70 text-center py-2">
            No exercises for this day
          </p>
        )}
      </AccordionContent>
    </AccordionItem>
  );
}

// Apply memoization - training days rarely change after loading
export const TrainingDay = React.memo(TrainingDayComponent);
